import { render, staticRenderFns } from "./course-list-settings-modal.vue?vue&type=template&id=597c1ac2&scoped=true"
import script from "./course-list-settings-modal.vue?vue&type=script&lang=js"
export * from "./course-list-settings-modal.vue?vue&type=script&lang=js"
import style0 from "./course-list-settings-modal.vue?vue&type=style&index=0&id=597c1ac2&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "597c1ac2",
  null
  
)

export default component.exports